import * as React from 'react';
import {View, createView} from '../view';
import type {Component, IntrinsicElement} from '../view';
import type {RuleInterpolation} from './core';
import type {CreateCss} from './createCss';

type CreateStyled<Instance extends IntrinsicElement> = (
  strings: string | TemplateStringsArray,
  ...args: RuleInterpolation[]
) => Component<unknown, Instance, undefined, undefined>;

/** @deprecated */
type IntrinsicViews = {
  [K in IntrinsicElement]: CreateStyled<K>;
};

/** @deprecated */
export function createStyled(deprecatedCss: CreateCss): IntrinsicViews {
  return new Proxy({} as IntrinsicViews, {
    // Performance: Use 'div' instead of adding a generic argument that extends
    // IntrinsicElement to prevent TypeScript from checking this method with
    // every intrinsic element. This speeds up type-checking by several seconds.
    get(_target: IntrinsicViews, tag: 'div'): CreateStyled<'div'> {
      return (declarations, ...args) => {
        const styles = deprecatedCss(declarations, ...args);
        return createView<unknown, 'div'>(
          /* @ts-expect-error downcasting */
          (props) => <View uses={[props, styles]} />,
          tag,
        );
      };
    },
  });
}
